// extracted by mini-css-extract-plugin
export default {"backToHomeLink":"Header_backToHomeLink__Xwxim","root":"Header_root__mLnFx","backToHome":"Header_backToHome__9S67w","lightMode":"Header_lightMode__p2pyY","logo":"Header_logo__wNYzc"};